import styled from '@emotion/styled';
import { css } from '@emotion/react';

import media from 'utils/media';

export const Section = styled.section`
  padding: 30px 20px;
  min-height: 560px;
  overflow: hidden;

  ${media.greaterThan.sm} {
    padding: 80px 0;
  }

  > div a {
    padding: 12px 2px 11px;
    width: 177px;
    min-width: 177px;
    height: auto;
    font-size: 14px;
    line-height: 17px;

    ${media.greaterThan.sm} {
      min-width: 260px;
      min-height: 50px;
      padding-top: 15px;
      padding-bottom: 16px;
      font-size: 16px;
      line-height: 19px;
    }
  }
`;

export const dynamicContentStyle = ({ isGlobalError }) =>
  isGlobalError &&
  css`
    position: relative;

    ${media.greaterThan.sm} {
      display: flex;
      justify-content: center;
    }
  `;

export const Content = styled.div`
  ${dynamicContentStyle};
`;

export const BigText = styled.h1`
  font-size: 70px;
  line-height: 1;
  margin-top: 5px;
  margin-bottom: 50px;

  ${media.greaterThan.xs} {
    font-size: 95px;
    margin-top: 25px;
  }

  ${media.greaterThan.lg} {
    font-size: 120px;
    margin-top: 40px;
    margin-bottom: 60px;
  }
`;

export const Title = styled.h1`
  font-size: 32px;
  line-height: 36px;
  margin-bottom: 42px;
`;

export const dynamicSubtitleStyle = ({ isGlobalError }) =>
  isGlobalError &&
  css`
    margin-top: 0;
    margin-bottom: 40px;
    max-width: 127px;

    p {
      font-size: 16px;
      line-height: 1.15;
    }

    ${media.greaterThan.sm} {
      max-width: 100%;
    }
  `;

export const SubtitleMarkdown = styled.div`
  margin-top: 42px;

  p {
    font-size: 18px;
    line-height: 21px;
  }

  ${dynamicSubtitleStyle};
`;

export const dynamicImgStyle = ({ isGlobalError }) =>
  isGlobalError &&
  css`
    position: absolute;
    top: 0;
    width: 100%;
    max-width: 264px;
    margin-top: 0;
    margin-left: 94px;
    transform: translateX(24px);
    z-index: -1;

    ${media.greaterThan.sm} {
      position: relative;
      right: 0;
      transform: none;
      max-width: 378px;
    }

    img {
      width: 100%;
    }
  `;

export const ImgWrap = styled.div`
  margin-top: 50px;
  ${dynamicImgStyle};
`;
